import i18next from 'i18next'

const extractReferences = (recordInfo) => {
    return recordInfo.records_reference.map((publi, i) => {
        if (i === recordInfo.records_reference.length - 1) {
            if (publi.publication_hyperlink) {
                return '<span class="sibic_wind_refer black-hyper" key={' + i + '}><a href="' + publi.publication_hyperlink + '" target="_blank">' + publi.publication_cite + '</a></span>'
            } else {
                return '<span class="sibic_wind_refer" key={' + i + '}>' + publi.publication_cite + '</span>'
            }
        } else {
            if (publi.publication_hyperlink) {
                return '<span class="sibic_wind_refer black-hyper" key={' + i + '}><a href="' + publi.publication_hyperlink + '" target="_blank">' + publi.publication_cite + '</a></span>, '
            } else {
                return '<span class="sibic_wind_refer" key={' + i + '}>' + publi.publication_cite + '</span>, '
            }
        }
    })
}


export const createSibicModal = (recordInfo) => {


    let references = extractReferences(recordInfo)

    let popUpText = '<div class="sibic_map_window container-fluid"><div class="row"><div class="col-12 sibic_wind_title">' + recordInfo.taxa + '</div></div><div class="row">'

    if (recordInfo.file_name) {
        popUpText += '<div class="col-5"><img class="mt-3 sibic_wind_img" src="https://admin.eei.sibic.org/assets/img/species/' + recordInfo.file_name + '" alt="img window" /></div><div class="col-6 offset-1 p-0">'
    } else {
        popUpText += '<div class="col-10 offset-2 p-0">'
    }

    popUpText += '<p class="sibic_wind_subtitle sibic_wind_general mb-0 mt-0 h2">'+i18next.t("generalInfo")+'</p>'
        + '    <p class="sibic_wind_info mb-0 mt-0">'
        + '       <strong>'+i18next.t("locality")+':</strong> ' + recordInfo.locality + '<br/>'
        + '       <strong>'+i18next.t("stretch_place")+':</strong> ' + recordInfo.stretch_place + '<br/>'
        + '       <strong>'+i18next.t("date_record")+':</strong> ' + recordInfo.record_date + '<br/>'
        + '    </p>'
        + '    <p class="sibic_wind_subtitle sibic_wind_referen mb-0 mt-0 h2">'+i18next.t("refsCard")+'</p>'
        + '    <p class="sibic_wind_info mb-2 mt-0">'
        + references
        + '    </p>'
        + '    </div>'
        + '</div>'
        + '</div>';

    return popUpText;
}
